import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shrink_icon",
  "use": "icon-shrink_icon-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-shrink_icon\">\n<g>\n\t<path d=\"M186,4H14C8.5,4,4,8.5,4,14v172c0,5.5,4.5,10,10,10h172c5.5,0,10-4.5,10-10V14C196,8.5,191.5,4,186,4z M184,184H16V16h168\n\t\tV184z\" />\n\t<path d=\"M46,106h48v48c0,3.3,2.7,6,6,6s6-2.7,6-6v-48h48c3.3,0,6-2.7,6-6s-2.7-6-6-6h-48V46c0-3.3-2.7-6-6-6s-6,2.7-6,6v48H46\n\t\tc-3.3,0-6,2.7-6,6S42.7,106,46,106z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol